module.exports = __webpack_public_path__ + "img/ing.ff5e1bb4.jpg";